import { computed } from 'vue';
import { provideLocal, injectLocal } from '@vueuse/core';
import useImageryStateStore from '~/stores/useImageryStateStore';

const IMAGERY_STATE: InjectionKey<ReturnType<typeof useImageryStateProvide>> = Symbol.for('IMAGERY_STATE');

export function useImageryStateProvide() {
  const store = useImageryStateStore();

  const currentPage = computed({
    get() {
      return store.currentPage;
    },
    set(value) {
      store.currentPage = value;
    },
  });

  const firstAltDot = computed({
    get() {
      return store.firstAltDot;
    },
    set(value) {
      store.firstAltDot = value;
    },
  });

  const currentPageOnHover = computed({
    get() {
      return store.currentPageOnHover;
    },
    set(value) {
      store.currentPageOnHover = value;
    },
  });

  const isOverlayOpen = computed({
    get() {
      return store.isOverlayOpen;
    },
    set(value) {
      store.isOverlayOpen = value;
    },
  });

  const isZoomedIn = computed({
    get() {
      return store.zoomStates.isZoomedIn;
    },
    set(value) {
      store.zoomStates.isZoomedIn = value;
    },
  });

  const zoomStates = computed({
    get() {
      return store.zoomStates;
    },
    set(value) {
      store.zoomStates = value;
    },
  });

  const updateFirstAltDot = (value: number) => {
    firstAltDot.value = value;
  };

  const updateCurrentPage = (index: number) => {
    currentPage.value = index;
  };

  const updateCurrentPageOnHover = (index: number) => {
    currentPageOnHover.value = index;
  };

  const updateCarousel = (index: number) => {
    currentPageOnHover.value = null;
    currentPage.value = index;
  };

  const updateOverlayOpen = (isOpen: boolean) => {
    isOverlayOpen.value = isOpen;
  };

  const toProvide = {
    currentPage,
    currentPageOnHover,
    firstAltDot,
    isOverlayOpen,
    updateCurrentPage,
    updateCurrentPageOnHover,
    updateCarousel,
    updateFirstAltDot,
    updateOverlayOpen,
    isZoomedIn,
    zoomStates,
  };

  provideLocal(IMAGERY_STATE, toProvide);
  return toProvide;
}

export const useImageryState = () => {
  const imageryState = injectLocal(IMAGERY_STATE);

  if (typeof imageryState === 'undefined') {
    throw new TypeError('useImageryStateProvide() is called without provider');
  }

  return imageryState;
};

export default { useImageryState, useImageryStateProvide };
